/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { useFiche, FicheContainer } from '@mairistem/fiche';

// import { recenseFicheService } from '@/services';

import RecenseFiche from './RecenseFiche';
import RecenseFicheBar from './RecenseFicheBar';

const RecenseFicheContainer = () => {
  const [service] = useFiche('/api/administres/recensement-citoyen/individus');

  return (
    <FicheContainer service={service} type="recense">
      {(p) => (
        <>
          <RecenseFicheBar {...p} />
          <RecenseFiche {...p} />
        </>
      )}
    </FicheContainer>
  );
};
// const RecenseFicheContainer = () => (
//   <FicheContainer
//     type="recense"
//     service={recenseFicheService}
//   >
//     <RecenseFiche />
//   </FicheContainer>
// );

export default RecenseFicheContainer;
